import React from "react";

function PrintHeader({ className, academicYear, assessmentName }) {
  const currentYear = new Date().getFullYear();
  
  return (
    <div className="alpaca-print-header">
      <img
        src={`${process.env.PUBLIC_URL}/assets/imgs/Alpaca-logo-white-outline.png`}
        alt="ALPACA"
        className="printout-logo"
        style={{ objectFit: "contain" }}
      />
      <div className="alpaca-print-header-text">
        <span className="alpaca-print-header-class">{className}</span>
        <span className="alpaca-print-header-year">
          School Year: {academicYear}
        </span>
        <span className="alpaca-print-header-year">
          Screener Name: {assessmentName}
        </span>
        <span className="alpaca-print-header-powered">
          Powered by ALPACA &copy; {currentYear}
        </span>
      </div>
    </div>
  );
}

export default PrintHeader;
